import { Container } from '@/atoms/Container/Container';
import { Skeleton } from '@/atoms/Skeleton/Skeleton';

/** Loading state of `ResourceCard`: type and source on top, title and description, image on the right. */
export function ResourceCardSkeleton() {
  return (
    <Container data-testid="resource-card-skeleton" className="gap-3 rounded-md p-4 sm:p-6">
      <Container className="flex-row items-center justify-between gap-3">
        <Skeleton className="h-4 w-20 rounded-md" />
        <Skeleton className="h-4 w-24 rounded-md" />
      </Container>
      <Container className="flex-row gap-4">
        <Container className="min-w-0 flex-1 gap-2">
          <Skeleton className="h-5 w-48 max-w-full rounded-md" />
          <Skeleton className="h-4 w-full rounded-md" />
          <Skeleton className="h-4 w-32 rounded-md" />
        </Container>
        <Skeleton className="size-20 shrink-0 rounded-md sm:size-24" />
      </Container>
    </Container>
  );
}
